/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Button, message, Popconfirm } from 'antd';

import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';

import Utils from '../../../Assets/Scripts/Utils';
import ScheduleUtils from '../../../Components/Schedule/ScheduleUtils';
import TaskCommentFunctions from '../../../Components/Schedule/TaskCommentFunctions';

function resolveUploadDeleteEvent(fieldName) {
  switch (fieldName) {
    case 'nfTransportation':
      return 'NFTransportationDelete';
    case 'nfTraining':
      return 'NFTrainingDelete';
    case 'initialAttendanceDocList':
      return 'InitialAttendanceListDelete';
    case 'finalAttendanceDocList':
      return 'FinalAttendanceListDelete';
    case 'instructorForm':
      return 'InstructorFormDelete';
    default:
      return '';
  }
}

async function persistDeletedFiles({
  isCustomField,
  fieldName,
  updatedFiles,
  form,
  taskData,
  handleTaskUpdate,
}) {
  if (isCustomField) {
    form.setFieldValue(['customFields', fieldName], updatedFiles);
    await handleTaskUpdate('save');
    return;
  }

  const updatedData = { ...taskData, [fieldName]: updatedFiles };
  form.setFieldValue(fieldName, updatedFiles);
  const eventName = resolveUploadDeleteEvent(fieldName);
  if (eventName) {
    await TaskCommentFunctions.addTaskCommentUploadFile(updatedData, eventName, 'Scheduling');
  }
  await handleTaskUpdate('save');
}

function readFieldFiles(taskData, fieldName, isCustomField) {
  if (isCustomField) {
    return taskData.customFields?.[fieldName] ?? [];
  }

  return taskData[fieldName] || [];
}

function UploadFileFieldComponent({
  handleTaskUpdate,
  form,
  task,
  fieldName,
  fieldPermission,
  isTaskReadOnly,
  isEditing,
  setUploadFileType,
  setUploadFileModalOpen,
  isCustomField,
}) {
  const taskData = { ...task, ...form.getFieldsValue() };

  const [files, setFiles] = useState(readFieldFiles(taskData, fieldName, isCustomField));

  const handleDelete = async (file, index) => {
    try {
      await form.validateFields();

      await ScheduleUtils.deleteAttachmentFromTask(file.name, taskData.id);

      const updatedFiles = files.filter((_, i) => i !== index);
      setFiles(updatedFiles);
      await persistDeletedFiles({
        isCustomField,
        fieldName,
        updatedFiles,
        form,
        taskData,
        handleTaskUpdate,
      });
    } catch (error) {
      message.warn(
        'Oops! Parece que alguns campos não foram preenchidos ou estão inválidos, verifique o formulário e tente novamente.',
        7
      );
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {/* Upload Button */}
      {fieldPermission.access === 2 && task?.stage?.id !== 5 && !isTaskReadOnly && isEditing && (
        <Button
          type="default"
          icon={<UploadOutlined />}
          style={{ width: 'fit-content' }}
          onClick={() => {
            setUploadFileType(isCustomField ? `customFields:${fieldName}` : fieldName);
            setUploadFileModalOpen(true);
          }}
        >
          Adicionar Arquivo
        </Button>
      )}

      {/* List of Files */}
      {files.map((file, index) => (
        <div key={index} style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <a
            href={Utils.resolveBitrixDownloadUrl(file.url)}
            target="_blank"
            className="custom-a"
            rel="noreferrer"
          >
            {Utils.attachmentDownloadLabel(file)}
          </a>

          {/* Delete Option */}
          {fieldPermission.access === 2 &&
            task?.stage?.id !== 5 &&
            !isTaskReadOnly &&
            isEditing && (
              <Popconfirm
                placement="topLeft"
                title="Tem certeza que deseja deletar o arquivo?"
                onConfirm={() => handleDelete(file, index)}
                okText="Sim"
                okType="danger"
                cancelText="Cancelar"
              >
                <DeleteOutlined style={{ color: '#fc5d20', cursor: 'pointer' }} />
              </Popconfirm>
            )}
        </div>
      ))}

      {files.length === 0 && !isEditing && (
        <span className="upload-file-field-no-data">o campo está vazio</span>
      )}
    </div>
  );
}

export default UploadFileFieldComponent;
